/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema showing the statuses of batch-created DIDComm messages.
 */
export interface DidCommMessageCreateBlobsStatus {
    messages: Truvity.DidCommMessageBlobStatus[];
}
